import { ProductVariant } from '@medusajs/medusa'
import { PricedVariant } from '@medusajs/medusa/dist/types/pricing'

export const canBuy = (variant: Omit<PricedVariant, 'beforeInsert'>) => {
  return variant.inventory_quantity! > 0 || variant.allow_backorder === true
}
